/* eslint-disable prefer-const */

import { H4, LabelWrapper } from '@gameday/react-components/components'
import theme from '@gameday/react-components/utils/theme'
import { KeyboardArrowDown } from '@material-ui/icons'
import { connect, Formik } from 'formik'
import FormikErrorFocus from 'formik-error-focus'
import { isEmpty } from 'lodash'
import { useEffect, useState } from 'react'
import styled, { css } from 'styled-components'
import { object } from 'yup'

import { filterSubEvents } from '../../../../factories/filter'
import productsListHook from '../../../../hooks/productsList'
import NavigationButtons from '../../Common/NavigationButton'
import ProductsList from '../Products/productsList'
import { FormikEffectComp, noSubEventsMsg } from '../Products/utils'

const StyledSubEvents = styled.div``
const StyledSubEvent = styled.div`
  border-bottom: 1px solid ${theme.colors.border};
  padding: 1em 0;
`
const StyledHeader = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 1rem 0;
`

const StyledLeft = styled.div`
  padding-right: 1rem;
`

const Styledh4 = styled(H4)``
const StyledDescription = styled.p`
  margin: 0 !important;
`

const StyledChevron = styled(KeyboardArrowDown)`
  cursor: pointer;
  transition: all 0.3s ease;
  ${props =>
    props.open &&
    css`
      transform: rotate(-180deg);
    `}
`

const FormikEffect = connect(FormikEffectComp)

const SubEventsComponent = ({
  subEvents = [],
  onSelected,
  buttonColour,
  buttonTextColour,
  previous,
  formType,
  formData,
  next,
  paidProducts,
  initialValues,
  formError,
  feeConfigurations,
  paymentGateway,
  preselectedProduct,
  hasSubEvents,
  mainProducts,
  productGroups,
}) => {
  let submit = () => {}
  const products = [...mainProducts]
  subEvents.forEach(s => {
    products.push(...s.products)
  })

  // Products are shared across forms, so purchases known to belong to another form
  // neither count toward this form's group limits nor block re-selection here.
  // biome-ignore lint/performance/noAccumulatingSpread: TODO
  const paidMap = paidProducts.filter(p => p.purchasedViaForm !== false).reduce((a, p) => ({ ...a, [p.sfid]: p }), {})

  const [isContinueDisabled, setContinueDisabled] = useState(true)
  const [toggles, setToggles] = useState(
    subEvents.reduce((a, c) => {
      a[c.id] = false
      return a
    }, {})
  )

  const { filteredProducts, filteredSubs } = filterSubEvents(subEvents, formData, paidMap, formType, mainProducts)

  const [pgMinimumFulfilled, setMinimumFulfilled] = useState(
    productGroups.reduce((a, pg) => {
      if (Number(pg.minimumProductCount) > 0) {
        a[pg.id] = false
      }
      return a
    }, {})
  )

  const [pgMaximumFulfilled, setMaximumFulfilled] = useState(
    productGroups.reduce((a, pg) => {
      if (Number(pg.maximumProductCount) > 0) {
        a[pg.id] = false
      }
      return a
    }, {})
  )

  useEffect(() => {
    subEvents.forEach(s => {
      if (!isEmpty(s.products.filter(p => p.isMandatory))) {
        setToggles(toggles => ({ ...toggles, [s.id]: true }))
      }
    })
  }, [])

  const { initValues, schema, childProductList, errorType, pgClone, groupMap, formProductIdMap, errorText } =
    productsListHook({
      paidMap,
      filteredProducts,
      productGroups,
      preselectedProduct,
      initialValues,
      isForSubEvents: true,
      filteredSubs,
    })

  const [displayGroupMap, setDisplayGroupMap] = useState({ groupMap })
  const [showUnpurchasable, setShowUnpurchasable] = useState(false)

  const renderProductList = (errors, touched, values, onProductChange) => (
    <StyledSubEvents>
      {(filteredSubs || [])
        .sort((a, b) => a.orderNumber - b.orderNumber)
        .map(s => {
          const identifier = s.id
          const pgMapIds = []
          s.products.forEach(p => pgMapIds.push(p.sfid))
          s.productGroups.forEach(pg => pgMapIds.push(pg.id))
          return (
            <StyledSubEvent key={s.id}>
              <StyledHeader
                onClick={() => setToggles(toggles => ({ ...toggles, [identifier]: !toggles[identifier] }))}
                data-testid="subevent"
              >
                <StyledLeft>
                  <Styledh4>{s.name}</Styledh4>
                  {s.description && <StyledDescription>{s.description}</StyledDescription>}
                </StyledLeft>
                <StyledChevron open={toggles[identifier]} />
              </StyledHeader>
              {pgClone
                .sort((a, b) => {
                  const orgLevelA = a.organisationLevel
                  const orgLevelB = b.organisationLevel
                  if (orgLevelA !== orgLevelB) {
                    return orgLevelA - orgLevelB
                  }
                  const lockA = a.isLocked ? 0 : 1
                  const lockB = b.isLocked ? 0 : 1
                  if (lockA !== lockB) {
                    return lockA - lockB
                  }
                  return a.orderNumber - b.orderNumber
                })
                .filter(pg => pgMapIds.includes(pg.id))
                .map(pg => {
                  const productsInGroup = displayGroupMap[pg.id]
                  return (
                    toggles[identifier] && (
                      <ProductsList
                        pg={pg}
                        paidMap={paidMap}
                        formType={formType}
                        onProductChange={onProductChange}
                        childProductList={childProductList}
                        errors={errors}
                        errorType={errorType}
                        errorText={errorText}
                        touched={touched}
                        values={values}
                        pgMinimumFulfilled={pgMinimumFulfilled}
                        pgMaximumFulfilled={pgMaximumFulfilled}
                        productsInGroup={productsInGroup}
                        feeConfigurations={feeConfigurations}
                        paymentGateway={paymentGateway}
                      />
                    )
                  )
                })}
            </StyledSubEvent>
          )
        })}
    </StyledSubEvents>
  )

  return (
    <>
      <h2>Sub Events</h2>
      {isEmpty(filteredSubs) && <LabelWrapper errorText={noSubEventsMsg} />}
      {formError && <LabelWrapper errorText={formError} />}
      {showUnpurchasable && (
        <LabelWrapper
          errorText="
            The product you selected is currently unavailable for selection due to member restrictions"
        />
      )}
      <Formik
        onSubmit={values => {
          onSelected(values)
          next()
        }}
        initialValues={initValues}
        enableReinitialize
        validationSchema={formType === 'event' ? object(schema) : object({})}
        validateOnChange={false}
        validateOnBlur={products.length <= 30}
      >
        {({ errors, touched, values, submitForm, setFieldValue, setFieldTouched }) => {
          submit = submitForm

          const onProductChange = (key, value) => {
            setFieldTouched(key, true)
            const formProductId = formProductIdMap[key]
            setFieldValue(key, { ...value, formProductId })
          }

          return (
            <form>
              {renderProductList(errors, touched, values, onProductChange)}
              <FormikEffect
                setContinueDisabled={setContinueDisabled}
                setShowUnpurchasable={setShowUnpurchasable}
                setMinimumFulfilled={setMinimumFulfilled}
                setMaximumFulfilled={setMaximumFulfilled}
                productGroups={productGroups}
                paidProducts={paidMap}
                products={products}
                groupMap={{ ...groupMap }}
                setDisplayGroupMap={setDisplayGroupMap}
                hasSubEvents={hasSubEvents}
                allowSkip={hasSubEvents && isEmpty(filteredSubs)}
                parentValues={formData.newProducts}
              />
              <FormikErrorFocus offset={-150} align="top" focusDelay={0} ease="in-out-quad" duration={250} />
            </form>
          )
        }}
      </Formik>
      <NavigationButtons
        buttonColour={buttonColour}
        buttonTextColour={buttonTextColour}
        isContinueDisabled={isContinueDisabled}
        onSubmit={() => {
          submit()
        }}
        onBack={() => {
          previous()
        }}
      />
    </>
  )
}

export default SubEventsComponent
